import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/new-home-component/Footer";
import Navbar from "../../components/new-home-component/Navbar";
import CollapsableCard from "../../components/collapsableCard";

const Terms = () => {
  const navigate = useNavigate();
  return (
    <div className="relative overflow-x-hidden min-h-[100vh] bg-[#274B89] sm:pt-[200px] pt-[300px]">
      <div className="bg-[#274B89]">
        <div
          className={`
         bg-[#274B89]
        fixed top-0 w-[100%] z-[100000000]`}
        >
          <Navbar />
          <p className="px-[5%] mt-[50px] text-left text-[#fff] font-[700] sm:text-[72px] text-[40px]">
            Terms of Service
          </p>
        </div>
        <div className="p-[5%] text-[#fff] mt-[20px]">
          <p className="m-auto pt-3 text-[25px] font-[600]">
            Please read these terms carefully as you are bound by them effective 1st of June, 2020.{" "}
          </p>
          <p className="font-[400] m-auto pt-3 text-[20px]">
            By downloading our app and signing up, you accept our terms and conditions of service.{" "}
          </p>
        </div>
        <div className="px-[8%] py-[2%] m-auto w-full">
          <CollapsableCard
            title="User-Generated Content and Acceptable Use"
            content={
            <> 
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
              By using this application, you agree to comply with the following rules regarding user-generated content and conduct:
            </p>
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
            <div>No Objectionable Content</div>
            Users must not create, upload, post, transmit, or share any content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, sexually explicit, hateful, or otherwise objectionable. This includes content that promotes violence, discrimination, or abuse toward individuals or groups.
            </p>
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
            <div>No Abusive Behavior</div>
            The App has zero tolerance for abusive behavior, including bullying, harassment, threats, impersonation, or any form of intimidation toward other users.
            </p>
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
            <div>User Responsibility</div>
            Users are solely responsible for the content they post and any interactions they engage in within the App. Posting objectionable content or engaging in abusive behavior is a violation of these Terms.
            </p>
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
            <div>Content Moderation and Enforcement</div>
            We reserve the right, but are not obligated, to review, monitor, remove, or restrict access to any user-generated content that violates these Terms, at our sole discretion and without prior notice.
            </p>
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
            <div>Account Suspension or Termination</div>
            We may suspend or permanently terminate user accounts that violate this policy, engage in abusive behavior, or repeatedly post objectionable content.
            </p>
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
            <div>Reporting Abuse</div>
            Users are encouraged to report objectionable content or abusive behavior through the reporting tools provided in the App or by contacting our support team. Reported content may be reviewed and acted upon in accordance with these Terms.
            </p>
            <p className="sm:text-[18px] text-[14px] mb-[20px]">
            By continuing to use the App, you acknowledge and agree to these rules and understand that violations may result in content removal and/or account termination.
            </p>
          </>
            }
          />

          <CollapsableCard
            title="1. Introduction"
            content={
            <> <p className="sm:text-[18px] text-[14px] mb-[20px]">
           Spottr is a productivity platform available online and through mobile applications.

          </p>
          </>
            }
          />
          
          <CollapsableCard
            title="1.1 Purpose"
            content={
            <> 
              <p className="sm:text-[18px] text-[14px] mb-[20px]">
              The Spottr app helps users to find economic opportunities globally by joining the main ecosystem. Opportunities include, but is not limited to, goods & services for sale, jobs, business opportunities, events, information and other wealth creating opportunities.
            </p>
          </>
            }
          />        
          <CollapsableCard
            title="1.2 Agreement"
            content={
              <>  

          <p className="mb-[60px] sm:text-[18px] text-[14px]">
       When you access our website at http://spottr.app and/or our mobile application(s) as a User and Client, you agree to be bound by the following Terms of Use. Therefore, please, take the time to read the following binding Terms of Use below.
          </p>
            <p className="sm:text-[18px] text-[14px] font-[600] mb-[20px]">
            For the purpose of this agreement
            </p>
            <p className="mb-[60px] sm:text-[18px] text-[14px]">
          a <b>User</b> is an individual who uses our website or mobile application to evaluate our service or for educational purposes
          </p>
          <p className="sm:text-[18px] text-[14px] font-[600] mb-[30px]">
            whereas
          </p>
          <p className="mb-[60px] sm:text-[18px] text-[14px]">
          a <b>Client</b> is an individual who signs up to the Spottr service that entitles the Client to find opportunities and engage in transactions.

          </p>
          <p className="mb-[60px] sm:text-[18px] text-[14px]">
            This Agreement, alongside our Privacy Policy, applies to both Users and Clients. 
            If you elect to become a Client, you will be subject to these Terms of Use, our Client Agreement, 
            our Privacy Policy and any additional terms to 
            which you agree to when you create or initiate any transaction(s).
          </p>
          
          </>
            }
          />
            <CollapsableCard
            title=" 2.0 Obligations"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
            You must be 18 or older to access our website or mobile applications.
          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 2.1  Eligibility"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
           Spottr is intended solely for individuals who are 18 or older. Any access to or use of Spottr by anyone under the age of 18 is unauthorized, unlicensed, and in violation of these Terms of Use. 
           By accessing or using Spottr, you represent and warrant that you are 18 or older.
          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 2.2  Your Access"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
           In order to access certain features of Spottr, you must register to create an account 
           ("User Account"). When you register, you will be asked to choose a password, which will be 
           required to access your User Account at any time. Spottr has physical, electronic and procedural 
           safeguards that comply with regulatory standards to guard Users' and Clients' non-public personal 
           information (see Privacy Policy). You are responsible for safeguarding your password and other User
            Account information. You agree not to disclose your password to any third party and you will notify 
            Spottr immediately if your password is lost or stolen or if you suspect any unauthorized use of your 
            User Account. As a User you agree that you shall be solely responsible for any activities or actions 
            under your User Account, whether or not you have authorized such activities or actions. 
            You agree that the information you provide to us on account registration through our website or mobile 
            application(s) will be true, accurate, current, and complete. If you wish to develop enhancements to 
            the Spottr service then you must do so via our "Partner Program" API. As used in these Terms, "APIs" 
            means programmatic web APIs and associated tools and documentation that provide access to certain 
            data displayed on our website or in our mobile applications. Access to our APIs requires you meet our 
            Partner Program eligibility criteria and enter into a signed partnership agreement with Spottr. 
            You may not scrape or copy information through any means (including crawlers, browser plugins and 
            add-ons, and any other technology or manual work) as explained in Section 6.2. 
           If you wish to learn more about becoming a Partner, please contact partner@spottr.app.
          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 2.3 Alerts, Notifications and Service Communications"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
          By creating a User Account, you automatically sign up for various types of alerts via 
          e-mail and mobile notifications. We never include your password in these communications, 
          but we may include your name, or email address and information about your portfolio(s) 
          if you are a Client. Anyone with access to your e-mail or mobile device will be able to view 
          these alerts. 
          You may unsubscribe from marketing-oriented emails at any time.
          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 2.4 Disclaimer and Limit of Liability"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
          Spottr cannot be held responsible for any opportunity insights or recommendations provided to users.
          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 3.1 For a User who is not a Client"
            content={
              <>  
              <p className="mb-[20px] sm:text-[18px] text-[14px]">
          You understand and acknowledge that the investment results you could obtain from investment 
          information and financial insights provided by Spottr cannot be guaranteed and that Spottr 
          cannot be held responsible. All investments entail a risk of loss and that you may lose money. 
          Investment management services may be offered to individuals who become clients, at the sole 
          discretion of Spottr. Your election to engage our wealth creating services are subject to your 
          explicit enrollment and acceptance of this Terms of Use. You agree and understand that your use 
          of Spottr is for educational purposes only and is not intended to provide legal, tax or 
          financial planning advice. You agree as a User that you are responsible for your own business 
          and investment research and decisions, that Spottr is only one of many tools you may use as 
          part of a comprehensive business and investment education process, that you should not and will 
          not rely on Spottr as the primary basis of your business and investment decisions and, except 
          as otherwise provided for herein, Spottr will not be liable for decisions/actions you take or 
          authorize third parties to take on your behalf based on information you receive as a User of 
          Spottr or information you otherwise see on our website.

          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 3.2   Disclaimer Warranties"
            content={
              <> 
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
          Your use of Spottr's website, and the personal information you provide is at your sole discretion. 
          Spottr's website and all materials, information, products and services included therein, 
          are provided on an AS IS and AS AVAILABLE basis without warranties of any kind from Spottr.
          </p> 
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
          Spottr expressly disclaims all warranties of any kind, express, implied or statutory, 
          relating to Spottr's website, content and/or user information, including without limitation 
          the warranties of title, merchantability, fitness for a particular purpose, non-infringement 
          of proprietary rights, course of dealing or course of performance. 
          Spottr disclaims any warranties, express or implied:
          </p>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
          Regarding the availability, security, accuracy, reliability, timeliness and performance of 
          Spottr's website, content and/or user information;
          </p>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
          <ul className="list-disc ml-[20px]">
            <li>that Spottr's website will be error-free or that any errors will be corrected;</li>
            <li>that Spottr's website will be free from electronic viruses; or Regarding the performance 
              of or accuracy, quality, currency, completeness or usefulness of any information provided by 
              Spottr on its website including but not limited to information obtained through social media.
            </li>
            <li>no advice or information, whether oral or written, obtained by you from Spottr's website, 
              shall create any warranty not expressly stated in this Agreement. If you choose to rely on 
              such information, you do so solely at your own risk.
            </li>
          </ul>
          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 3.3 Limitation of Liability"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
          In no event shall Spottr or any of its officers, directors, employees, or agents be 
          liable to you for any damages whatsoever, including without limitation indirect, incidental, 
          special, punitive, or consequential damages, arising out of or in connection with your use of Spottr, 
          content and/or user information, including but not limited to the quality, accuracy, or utility of 
          the information provided as part of or through Spottr or for any transaction decisions made on the 
          basis of such information, whether the damages are foreseeable and whether or not Spottr has been 
          advised of the possibility of such damages. The foregoing limitation of liability shall apply to the 
          fullest extent permitted by law in the applicable jurisdiction and 
          in no event shall Spottr's cumulative liability to you exceed 10,000 NGN.
          </p>
          </>
            }
          /> 
          <CollapsableCard
            title=" 4.0 Termination"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
        Each of us can end this agreement at any time, subject to the maturity of all plans. 
        You may request termination of your User Account at any time and for any reason by sending an 
        email to hello@spottr.app. We may terminate or suspend your access to Spottr, in our sole discretion, 
        at any time for any reason without notice to you. Further, if we believe, in our sole discretion, 
        that a violation of these Terms of Use has occurred, we may take any other corrective action we deem 
        appropriate. We reserve the right to investigate suspected violations of these Terms of Use. 
        We may seek to gather information from a user who is suspected of violating these Terms of 
        Use (or from any other user) and you agree to provide us with such information.
          </p>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
       We will fully cooperate with any law enforcement authority or court order requesting or 
       directing us to disclose useful information that violate these Terms of Use. Any suspension, 
       termination, or cancellation shall not affect your obligations to Spottr under these 
       Terms of Use (including but not limited to ownership, indemnification, and limitation of liability), 
       which by their sense and 
       context are intended to survive such suspension, termination, or cancellation.
          </p>
          </>
            }
          /> 
        <CollapsableCard
            title=" 5.0 Dispute Resolution"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
          If there is a legal dispute, it will take place in Federal High Courts under Nigerian Law. 
          You agree that these Terms of Use shall be governed by and 
          interpreted in accordance with the laws of the Federal Republic of Nigeria.
          </p>
          </>
            }
          />
          <CollapsableCard
            title=" 6.0 Spottr 'Dos' and 'Don'ts"
            content={
              <>  
              <p className="mb-[20px] sm:text-[18px] text-[14px]">
          Spottr grants you a license to use our website and mobile application(s) 
          so long as you comply with all our rules.
          </p>
          <h3 className="sm:text-[20px] text-[16px] font-[600] mb-[10px]">6.1   Dos: You agree you will:</h3>
          <ul className="list-disc ml-[20px] mb-[20px]">
            <li>comply with all applicable laws, including, without limitation, privacy laws, intellectual property laws, anti-spam laws, export control laws, tax laws, and regulatory requirements; </li>
            <li>provide accurate information to us, whether reported directly or through a third party who you authorize, and keep it updated;</li>
            <li>use real names and/or verified aliases in your profile</li>
            <li> keep your password confidential;</li>
            <li>use the Services in a professional manner.</li>
          </ul>
          <h3 className="sm:text-[20px] text-[16px] font-[600] mb-[10px]">6.2   Don’ts: You agree you won't:</h3>
          <ul className="list-disc ml-[20px] mb-[20px]">
            <li>circumvent, disable, or otherwise interfere with security-related features of Spottr or features that prevent 
              or restrict use or copying of any content or User information</li>
            <li>upload, email, transmit, provide, or otherwise make available:</li>
              <p className="mb-[10px] sm:text-[18px] text-[14px]">
                any User information which you do not have the lawful right to use, copy, transmit, display, or make available (including any User information that would violate any confidentiality or fiduciary obligations that you might have with respect to the User information); or
              </p>
              <p className="mb-[10px] sm:text-[18px] text-[14px]">
                any User information that infringes the intellectual property rights of, or violates the privacy rights of, any third-party (including without limitation copyright, trademark, patent, trade secret, or other intellectual property right, moral right, or right of publicity); or
              </p>
              <p className="mb-[10px] sm:text-[18px] text-[14px]">
                unsolicited or unauthorized advertising, promotional materials, junk mail, spam, chain letters, pyramid schemes, or any other form of solicitation; or
              </p>
              <p className="mb-[10px] sm:text-[18px] text-[14px]">
                any personal information that is unlawful, obscene, harmful, threatening, harassing, defamatory, or hateful, or that contain objects or symbols of hate, invade the privacy of any third-party, contain nudity, are deceptive, threatening, abusive, inciting of unlawful action, or are otherwise objectionable in the sole discretion of Spottr; or
              </p>
              <p className="mb-[10px] sm:text-[18px] text-[14px]">
                any personal information that contains software viruses or any other computer code, files, or programs designed to (i) interrupt, destroy, or limit the functionality of any computer software; or (ii) interfere with the access of any user, host or network, including without limitation overloading, flooding, spamming, mail-bombing, or sending a virus to Spottr; or
              </p>
              <p className="mb-[10px] sm:text-[18px] text-[14px]">
                any personal information that includes code that is hidden or otherwise surreptitiously contained within the User information;
              </p>
            <li>use any meta tags or other hidden text or metadata utilizing a Spottr name, trademark, URL or product name;</li>
            <li>forge any TCP/IP packet header or any part of the header information in any posting, or in any way use Spottr to send altered, deceptive, or false source-identifying information;</li>
            <li>interfere with or disrupt (or attempt to interfere with or disrupt) any Spottr web page, server, or network, or the technical delivery systems of Spottr's providers, or disobey any requirements, procedures, policies, or regulations of networks connected to Spottr.</li>
            <li>attempt to probe, scan, or test the vulnerability of any Spottr system or network or breach or impair or circumvent any security or authentication measures protecting Spottr;</li>
            <li>attempt to decipher, decompile, disassemble, or reverse-engineer any of the software used to provide Spottr;</li>
            <li>attempt to access, search, or meta-search Spottr or content thereon with any engine, software, tool, agent, device, or mechanism other than software and/or search agents provided by Spottr or other generally available third- party web browsers, including without limitation any software that sends queries to Spottr to determine how a website or web page ranks;</li>
            <li> violate the terms of service or any other rule or agreement applicable to you or Spottr's inclusion in, reference to, or relationship with any third party or third-party site or service, or your use of any such third-party site or service; Collect or store personal information about other users without their express permission;</li>
            <li>impersonate or misrepresent your affiliation with any person or entity, through pretexting or some other form of social engineering, or commit fraud;</li>
            <li>solicit any User for any investment or other commercial or promotional transaction;</li>
            <li>violate any applicable law, regulation, or ordinance;</li>
            <li>scrape or copy information through any means (including crawlers, browser plugins and add-ons, and any other technology or manual work);</li>
            <li> use, launch, or permit to be used any automated system, including without limitation "robots," "crawlers," or "spiders"; or</li>
            <li>copy or use the information, content or data on Spottr in connection with a competitive service (as determined by Spottr);</li>
            <li>monitor Spottr's availability, performance or functionality for any competitive purposes</li>
            <li> use Spottr or content thereon in any manner not permitted by these Terms of Use</li>
            <li>copyrighted Materials: No Unauthorized Use. If you become aware of misuse of Spottr or content thereon by any person, please contact Spottr to report any abuse. Spottr has adopted and implemented a policy that provides for the termination of Accounts of users who infringe the rights of copyright holders. Please see the Spottr Copyright and Intellectual Property Policy for further information.</li>

            </ul>
          </>
            }
          />
          <CollapsableCard
            title=" 7.0 General Terms"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
          In the event that any provision in these Terms of Use is held to be invalid or unenforceable, the remaining provisions will remain in full force and effect. The failure of a party to enforce any right or provision of these Terms of Use will not be deemed a waiver of such right or provision. You may not assign this Agreement (by operation of law or otherwise) without the prior written consent of Spottr, and any prohibited assignment will be null and void.
          </p>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
            Spottr may assign this Terms of Use Agreement or any rights hereunder without your consent. The relationship of the parties under these Terms of Use is that of independent contractors, and these Terms of Use will not be construed to imply that either party is the agent, employee, or joint venture of the other. Note that if you elect to become a Client, the relationship of the parties will be governed by these Terms of Use, our Privacy Policy and any additional terms to which you agree when you create an account or proceed to initiate and fulfil a transaction request. We reserve the right to change this Agreement by posting a revised Terms of Use and we agree that changes cannot be retroactive. If you don't agree with these changes, you must stop using Spottr. You agree the only way to provide us legal notice is at the address provided in Section 9.4.
          </p>
          </>
            }
          />
        <CollapsableCard
            title=" 8.0 International Use"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
          Spottr is available for use worldwide
          </p>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
            We make no representation that Spottr is appropriate for use in your country. Similarly, we make no representations that accessing Spottr from locations outside Nigeria is legal or permissible by local law. If you access Spottr from areas outside of Nigeria, you do so at your own risk and are yourself responsible for compliance with local laws.
          </p>
          </>
            }
          />
          <CollapsableCard
            title=" 9.0 Miscellaneous"
            content={
              <>  <p className="mb-[20px] sm:text-[18px] text-[14px]">
          This Agreement takes priority over previous agreements
          </p>
          <h3 className="sm:text-[20px] text-[16px] font-[600] mb-[10px]">9.1 Integration & Severability</h3>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
            This Agreement is the entire agreement between you and us with respect to Spottr, and your use of our website and mobile app, and supersedes all prior or contemporaneous communications and proposals (whether oral, written or electronic) between you and us. If any provision of this Agreement is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that this Agreement will otherwise remain in full force and effect. The failure of either party to exercise in any respect any right provided for herein shall not be deemed a waiver of any further rights hereunder. Business and investment recommendations are made to Clients on an individual basis and may differ based on specific circumstances.
          </p>
          <h3 className="sm:text-[20px] text-[16px] font-[600] mb-[10px]">9.2 Communication: Any notice or communication will be in writing by email</h3>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
            You agree that these Terms of Use and the rules, restrictions, and policies contained herein, and Spottr's enforcement thereof, are not intended to confer and do not confer any rights or remedies on any person other than you and Spottr. These Terms of Use together with the Spottr's Privacy Policy and Client Agreement (if applicable) constitute the entire agreement between Spottr and you with respect to the subject matter hereof. Any notice or other communication to be given hereunder will be in writing and given by
          </p>
          <ul className="list-disc ml-[20px] mb-[20px]">
            <li>Spottr via email (in each case to the address that you provide), or</li>
            <li>you via email to hello@spottr.app or to such other addresses as Spottr may specify in writing.</li>
          </ul>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
          The date of receipt shall be deemed the date on which such notice is transmitted.
          </p>
          <h3 className="sm:text-[20px] text-[16px] font-[600] mb-[10px]">9.3 Feedback: We welcome your feedback!</h3>
          <p className="mb-[20px] sm:text-[18px] text-[14px]">
            Your feedback is welcome and encouraged. You may submit feedback by emailing us at hello@spottr.app. You agree, however, that
            </p>
            <ul className="list-disc ml-[20px] mb-[20px]">
              <li>by submitting unsolicited ideas to Spottr or any of its employees or representatives, by any medium, including but not limited to email, written, or oral communication, you automatically forfeit your right to any intellectual property rights in such ideas; and</li>
              <li>such unsolicited ideas automatically become the property of Spottr. You hereby assign and agree to assign all rights, title, and interest you have in such feedback and ideas to Spottr together with all intellectual property rights therein. In addition, you warrant that all moral rights in any feedback have been waived, and you do hereby waive any such moral rights.</li>
            </ul>

          <h3 className="sm:text-[20px] text-[16px] font-[600] mb-[10px]">9.4 Questions: If you have any questions</h3>
          <p className="mb-[60px] sm:text-[18px] text-[14px]">
            This document constitutes Spottr's complete Terms of Service for Spottr and related services. If you have questions about these Terms of Services or about Spottr or content thereon, please contact Spottr at hello@spottr.app
            </p>
            <p className="mb-[20px] sm:text-[18px] text-[14px]">
              You can also contact Spottr by phone at +234 (0) 807 333 6660 or via physical mail at: <a href="mailto:hello@spottr.app" className="">Spottr</a>
            </p>
          </>
            }
          />
     
        </div>
      </div>
        <div className="max-w-7xl mx-auto px-4 md:px-0">
          <Footer />
        </div>
    

    </div>
  );
};

export default Terms;
